import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ModalService } from '@shared/services/modal/modal.service';

@Component({
  standalone: false,
  selector: 'gstar-header-modal',
  templateUrl: './header-modal.component.html',
  styleUrls: ['./header-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderModalComponent {
  private readonly modalService = inject(ModalService);

  @Input() title?: string;
  @Input() id!: string;
  @Input() hasCloseButton = true;

  @Output() dismiss: EventEmitter<void> = new EventEmitter();

  @ViewChild('headerContainer', { static: true })
  headerContent?: ElementRef<HTMLElement>;

  get hasNotChildren(): boolean {
    return (
      !!this.headerContent &&
      !!this.headerContent.nativeElement &&
      this.headerContent.nativeElement.childNodes.length === 0
    );
  }

  cancelHandler(): void {
    this.modalService.close(this.id);
    this.dismiss.emit();
  }
}
